var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvReadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Group_9761",
    width: 15,
    height: 15,
    "data-name": "Group 9761",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8855",
    fill: "none",
    d: "M0 0h15v15H0z",
    "data-name": "Path 8855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8856",
    fill: "#0073b1",
    d: "M10.237 6.18l-6.172 6.14-2.174-2.156a.624.624 0 0 0-.881 0 .617.617 0 0 0 0 .876l2.611 2.6a.624.624 0 0 0 .881 0l6.616-6.576a.617.617 0 0 0 0-.876h-.006a.611.611 0 0 0-.875-.008zm4.411.006h-.006a.611.611 0 0 0-.875-.006l-6.172 6.14-.52-.514-.883.878.959.954a.624.624 0 0 0 .881 0l6.616-6.576a.617.617 0 0 0 0-.876z",
    "data-name": "Path 8856",
    transform: "translate(-.307 -2.227)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvReadIcon);
export default __webpack_public_path__ + "static/media/conv-read-icon.5551a16db1113de4c3c8f622e5965dc6.svg";
export { ForwardRef as ReactComponent };